import type { InfoMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";

type DefinitionRow = {
  definition: string;
  pinyin: string;
};

export function assembleInfoMorphemeSliceDefinitionList(
  definitionRows: DefinitionRow[],
): InfoMorphemeSlice["definitionList"] {
  const entriesByPinyin = new Map<string, Set<string>>();
  const pinyinOrder: string[] = [];
  for (const row of definitionRows) {
    let entries = entriesByPinyin.get(row.pinyin);
    if (entries === undefined) {
      entries = new Set();
      entriesByPinyin.set(row.pinyin, entries);
      pinyinOrder.push(row.pinyin);
    }
    entries.add(row.definition);
  }
  return pinyinOrder.map((pinyin) => ({
    entries: [...(entriesByPinyin.get(pinyin) ?? [])],
    pinyin,
  }));
}
